import { usePayerConnectionsLive } from '../store/usePayerConnectionsLive';

import { AdminPayerConnectionsView } from './AdminPayerConnectionsView';

export function AdminPayerConnections({ organizationId }: { organizationId: string }) {
  const { rows, refetch, ...data } = usePayerConnectionsLive(organizationId);
  return <AdminPayerConnectionsView {...data} rowCount={rows.length} onRetry={refetch} />;
}
